export default {
  getAnoFiltros() {
    let result = []
    const data = new Date()
    let dataInicio = 2017
    const anoAtual = (data.getFullYear() + 1)


    while(dataInicio <= anoAtual){

      result.push({
        value: dataInicio, nome: dataInicio
      })
      dataInicio += 1
    }

    return result

  }
}
